import { Provider } from "react-redux";
import React from "react";
import "./App.css";
import MainContent from "./mainContent";
import 'react-phone-number-input/style.css';
import "react-country-state-city/dist/react-country-state-city.css";

const App = ({ store }) => (
  <Provider store={store}>
    <div className="App">
      <MainContent />
    </div>
  </Provider>
);

export default App;
